import { IconButton, Box } from '@mui/material';
import { ChevronDown } from 'lucide-react';

interface ScrollArrowProps {
  onClick: () => void;
  top?: number | string;
  showOnMobile?: boolean;
}

export default function ScrollArrow({ onClick, showOnMobile = false }: ScrollArrowProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        opacity: 0.7,
        animation: 'bounce 1.5s infinite',
        '@keyframes bounce': {
          '0%, 100%': { transform: 'translateY(0)' },
          '50%': { transform: 'translateY(10px)' },
        },
      }}
    >
      <IconButton
        onClick={onClick}
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          '&:hover': { bgcolor: 'primary.dark' },
          display: {
            xs: showOnMobile ? 'flex' : 'none',
            md: 'flex',
          },
        }}
      >
        <ChevronDown />
      </IconButton>
    </Box>
  );
}
